var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.354 10.646a.5.5 0 010 .708l-3.647 3.645L4.5 15a.5.5 0 01.492.41L5 15.5a.5.5 0 01-.5.5H1a1 1 0 01-1-1v-3.5a.5.5 0 011 0v2.792l3.646-3.646a.5.5 0 01.708 0zm6 0L15 14.292V11.5a.5.5 0 01.41-.492L15.5 11a.5.5 0 01.5.5V15a1 1 0 01-1 1h-3.5a.5.5 0 010-1h2.794l-3.648-3.646a.5.5 0 11.708-.708zM15 0a1 1 0 011 1v3.5a.5.5 0 01-1 0V1.706l-3.646 3.648a.5.5 0 11-.708-.708L14.292 1H11.5a.5.5 0 01-.492-.41L11 .5a.5.5 0 01.5-.5H15zM4.5 0a.5.5 0 010 1H1.708l3.646 3.646a.5.5 0 11-.708.708L1 1.706V4.5a.5.5 0 01-.41.492L.5 5a.5.5 0 01-.5-.5V1a1 1 0 011-1h3.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/assets/full-screen.953ddd12.svg";
export { ForwardRef as ReactComponent };